import { isCancel } from 'axios'
import axios from '../../utils/axios'
import { API_BASE_URL } from '../../constants'

export const deleteBedFile = async (fileId) => {
  try {
    const { data } = await axios.delete(`${API_BASE_URL}/bed/${fileId}`)

    return data
  } catch (error) {
    if (!isCancel(error)) {
      throw error
    }
  }
}
